const SEO = [
	{
		page: "home",
		description:
			"I am a backend developer with expertise in Node.js. I have experience in building scalable, secure and reliable web applications using various frameworks and technologies.",
		keywords: ["Than Kywe", "Than Kywe", "Ah Kywe"],
	},

	{
		page: "about",
		description:
			"I am a backend developer with expertise in Node.js. I have experience in building scalable, secure and reliable web applications using various frameworks and technologies.",
		keywords: ["Than Kywe", "Than Kywe", "Ah Kywe"],
	},

	{
		page: "articles",
		description:
			"Chronological collection of my long-form thoughts on programming, leadership, product design, and more.",
		keywords: ["Than Kywe", "Than Kywe", "Ah Kywe"],
	},

	{
		page: "projects",
		description:
			"As a backend developer, I specialize in building scalable, secure, and high-performance applications using Node.js, NestJS, and modern backend technologies. Over the years, I've worked on diverse projects, creating impactful solutions that drive efficiency and innovation. Many of my projects are open-source, encouraging collaboration and contributions. If you're interested in exploring my work or have ideas for improvements, I’d love to connect! Feedback and collaboration keep me inspired and continuously learning. 🚀",
		keywords: ["Than Kywe", "Than Kywe", "Ah Kywe"],
	},

	{
		page: "contact",
		description:
			"If you're interested in collaborating on a project, feel free to reach out to me. I'm always open to new ideas and opportunities.",
		keywords: ["Than Kywe", "Than Kywe", "Ah Kywe"],
	},
];

export default SEO;
